import React from 'react';
import { SEOHeadBundesweit } from '../components/SEOHeadBundesweit';
import { Header } from '../components/Header';
import { HeroBundesweit } from '../components/bundesweit/HeroBundesweit';
import { KurzErklaertBundesweit } from '../components/bundesweit/KurzErklaertBundesweit';
import { WieFunktioniertEs } from '../components/bundesweit/WieFunktioniertEs';
import { WannVorOrt } from '../components/bundesweit/WannVorOrt';
import { VorbereitungCheckliste } from '../components/bundesweit/VorbereitungCheckliste';
import { QualitaetVertrauen } from '../components/bundesweit/QualitaetVertrauen';
import { BrueckeGutachten } from '../components/bundesweit/BrueckeGutachten';
import { FAQBundesweit } from '../components/bundesweit/FAQBundesweit';
import { AbschlussBundesweit } from '../components/bundesweit/AbschlussBundesweit';
import { Footer } from '../components/Footer';
import { MobileStickyCTA } from '../components/MobileStickyCTA';

const BundesweitPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHeadBundesweit />
      <Header />
      <main>
        <HeroBundesweit />
        <KurzErklaertBundesweit />
        <WieFunktioniertEs />
        <WannVorOrt />
        <VorbereitungCheckliste />
        <QualitaetVertrauen />
        <BrueckeGutachten />
        <FAQBundesweit />
        <AbschlussBundesweit />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

export default BundesweitPage;